import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mathRound',
  standalone: false,
})
export class RoundPipe implements PipeTransform {
  transform(value: number): number {
    return Math.round(value);
  }
}
